// Roterende, redaktionelt indhold – skifter automatisk med kalenderen.
// Bevidst statisk: dette er redaktørens (min) egen stemme, ikke AI.

function weekOfYear(d = new Date()): number {
  const target = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  const dayNum = (target.getUTCDay() + 6) % 7;
  target.setUTCDate(target.getUTCDate() - dayNum + 3);
  const firstThursday = new Date(Date.UTC(target.getUTCFullYear(), 0, 4));
  const diff = (target.getTime() - firstThursday.getTime()) / 86400000;
  return 1 + Math.round((diff - 3 + ((firstThursday.getUTCDay() + 6) % 7)) / 7);
}

// ––– Fra redaktionen (månedligt) –––
const EDITORIALS: string[] = [
  "Januar er en lang sætning uden komma. Læs langsomt.",
  "Februar: mørket trækker sig, men lyset skal vænnes til. Hold ud.",
  "Marts smager af jord og forsigtighed. Et glas hvidvin ved et vindue.",
  "April er en digters måned – alt er endnu ikke skrevet.",
  "Maj: cykl uden mål. Byen er ny, når man ikke skal noget.",
  "Juni holder vejret. Læs et digt udenfor.",
  "Juli. Læg telefonen. Læs en hel bog i én siddende.",
  "August lugter af afsked. Skriv et brev til nogen.",
  "September: alvor og appetit. Kog længe.",
  "Oktober. Jazz og regn hører sammen af en grund.",
  "November er en lang stue. Tænd lys tidligt.",
  "December: mindre, ikke mere. Ét ordentligt glas vin.",
];

// ––– Ugens iagttagelse (Leth-inspireret, roterer ugentligt) –––
const OBSERVATIONS: { text: string; place?: string }[] = [
  { text: "En mand ved et cafébord skænker vand i sit glas, før han skænker vin. Han gør det uden at tænke over det. Det er en hel filosofi.", place: "Café, eftermiddag" },
  { text: "Kvinden på cyklen holder styret med én hånd og en avis med den anden. Hun læser overskrifterne mens hun triller ned ad gaden.", place: "Nørrebrogade, morgen" },
  { text: "En dreng lytter til jazz gennem hovedtelefoner. Han bevæger foden i en rytme, ingen andre kan høre. Det er den perfekte hemmelighed." },
  { text: "På markedet vejer manden tomaterne to gange. Første gang for vægten, anden gang for sikkerhed. Sådan skal alt vigtigt vejes.", place: "Torvehallerne" },
  { text: "En ældre kvinde spiser en bøf helt alene på restauranten. Hun skærer små stykker. Hun har hele aftenen." },
  { text: "Regnen falder på asfalten og forvandler byen til noget fransk. Alle går pludselig langsommere." },
  { text: "En cyklist stopper for at binde sit skoslør. Han bliver stående et øjeblik længere end nødvendigt, som for at nyde pausen." },
  { text: "En pige læser en tyk bog i toget. Hun mærker ikke stationerne. Det er sådan man læser, når man er ung." },
  { text: "Manden bag disken skænker kaffen fra en meter over koppen. Det er ren teater, og det er derfor kaffen smager af mere." },
  { text: "En violinist spiller på hjørnet, og en hund sætter sig ned og lytter. Kun hunden lytter helt." },
  { text: "To gamle mænd deler en flaske vin uden at tale. De har allerede sagt alt for længe siden." },
  { text: "En kvinde ryger en cigaret på en balkon i femte sal. Hun kigger ikke på noget bestemt. Hun kigger på alt." },
  { text: "Bageren tager et brød ud af ovnen og banker på bunden. Han lytter, som en læge lytter til et hjerte." },
];

// ––– Dagens læsestund (fuldtekst, roterer dagligt) –––
const READINGS: {
  title: string;
  author: string;
  year?: string;
  form: "digt" | "uddrag" | "brev";
  /** Hvor uddraget stammer fra – vises på forsiden, så læseren kan se at
   *  teksten har en ægte kilde og ikke er noget en maskine har fundet på. */
  source?: string;
  text: string;
}[] = [
  // Rækkefølgen er bevidst: ingen digter må optræde to uger i træk,
  // så "Ugens digt" altid føles som en ny stemme (også ved wrap-around).
  {
    title: "Regn",
    author: "Inger Christensen",
    year: "1969",
    form: "digt",
    text: "Jeg ser de lette skyer\nJeg ser den lette sol\n\nJeg ser hvor let de tegner\net endeløst forløb\n\nsom om de ved at jeg\nfindes som om jeg\nikke ved at de findes\n\nsom om de ved at de\nforsvinder som om jeg\nikke ved at jeg forsvinder",
  },
  {
    title: "Det perfekte menneske (uddrag)",
    author: "Jørgen Leth",
    year: "1967",
    form: "uddrag",
    source: "Uddrag af speaken i filmen Det perfekte menneske, instrueret og skrevet af Jørgen Leth, 1967",
    text: "Her er et øje. Her er et øre. Her er et ansigt. Her er et menneske. Det er det perfekte menneske. Vi vil se, hvordan det perfekte menneske fungerer. Vi vil se, hvordan det perfekte menneske bevæger sig. Vi vil se, hvordan det perfekte menneske tænker. Hvad tænker det på? Hvad vil det?",
  },
  {
    title: "Til en veninde",
    author: "Tove Ditlevsen",
    form: "digt",
    text: "Der er en dør der lukker sig indeni.\nDer er et rum der bliver stille.\nDer er en stemme der holder op\nmed at spørge dig om noget.\n\nDer er en fred der er ikke fred,\nmen bare det at være færdig\nmed at vente på et svar.",
  },
  {
    title: "Rilke, brev til en ung digter (uddrag)",
    author: "Rainer Maria Rilke",
    year: "1903",
    form: "brev",
    source: "Uddrag af fjerde brev i Breve til en ung digter (Briefe an einen jungen Dichter), 1903",
    text: "Vær tålmodig med alt det uafklarede i Deres hjerte, og prøv at holde af selve spørgsmålene, som var de aflåste værelser og bøger skrevet på et helt fremmed sprog. Søg ikke svarene, som ikke kan gives Dem endnu, fordi De ikke ville kunne leve dem. Og det gælder om at leve alt. Lev spørgsmålene nu. Måske lever De så, lidt efter lidt, umærkeligt, en fjern dag ind i svaret.",
  },
  {
    title: "Sommerfugledalen (åbning)",
    author: "Inger Christensen",
    year: "1991",
    form: "uddrag",
    source: "Åbningen af sonetkransen Sommerfugledalen. Et requiem, 1991",
    text: "Op stiger sommerfuglene i dalen,\nfra jordens varme krop, en sværm af farver\nsom kommer op af intet og går ind i intet.\n\nDe stiger op, og deres vinger vejer\nmindre end den luft, de flyver i.",
  },
  {
    title: "Bastian Emil, i en samtale",
    author: "efter hukommelsen",
    form: "uddrag",
    source: "Gengivet efter hukommelsen fra en samtale – ikke et ordret citat",
    text: "Man skal ikke være bange for at kede sig. Kedsomheden er ikke fjenden. Fjenden er den evige undvigelse af kedsomheden – de små skærme, de små beskeder, den lille dopamin. Kedsomheden er der, hvor tanken begynder.",
  },
  {
    title: "Cavafy – Ithaka (uddrag)",
    author: "Konstantin Kavafis",
    year: "1911",
    form: "digt",
    source: "Uddrag af digtet Ithaka, første gang trykt 1911",
    text: "Når du drager af sted mod Ithaka,\nønsk da, at rejsen bliver lang,\nfuld af eventyr, fuld af erkendelse.\n\nHold altid Ithaka i tankerne.\nAt komme dertil er dit mål.\nMen skynd dig ikke.\nDet er bedre, at rejsen tager mange år.",
  },
  {
    title: "Rifbjerg – Livet i badeværelset",
    author: "Klaus Rifbjerg",
    form: "uddrag",
    source: "Gengivet efter hukommelsen i Rifbjergs ånd – ikke et ordret citat",
    text: "Der er en form for hellighed ved et badeværelse tidligt om morgenen, når huset endnu sover. Vandhanen der drypper, spejlet der endnu ikke har set nogen, lyset der er nyt. Man står der og er ingen. Det er det bedste øjeblik af hele dagen.",
  },
  {
    title: "Alene",
    author: "Tomas Tranströmer",
    year: "1966",
    form: "digt",
    source: "Uddrag af digtet Ensomhed (Ensamhet) fra samlingen Klanger och spår, 1966",
    text: "En februaraften var jeg nær ved at dø her.\nBilen skred sidelæns på isen, ud\npå den forkerte side af vejen.\n\nJeg blev til et barn på en legeplads,\nhvor tiden er lang og ingen bliver kaldt hjem.\nJeg måtte ud af bilen og ind i sneen\nog stå længe og se på stjernerne.",
  },
  {
    title: "Ode til vinen (uddrag)",
    author: "Pablo Neruda",
    year: "1954",
    form: "digt",
    source: "Uddrag af Oda al vino fra Odas elementales, 1954",
    text: "Vin med dagens farve,\nvin med nattens fod,\nvin med purpurfødder\neller topas-blod,\n\nstjerne-\nbarn\naf jorden,\nvin, glat\nsom et sværd af guld,\nblød\nsom uordnet fløjl.",
  },
  {
    title: "Tobaksforretningen (åbning)",
    author: "Fernando Pessoa",
    year: "1928",
    form: "digt",
    source: "Åbningen af Tabacaria, skrevet under heteronymet Álvaro de Campos, 1928",
    text: "Jeg er ingenting.\nJeg vil aldrig blive noget.\nJeg kan ikke ville blive noget.\nBortset fra det rummer jeg alle verdens drømme.\n\nVinduer i mit værelse,\ni mit værelse blandt millioner i verden, som ingen ved hvem er.",
  },
  {
    title: "Muligheder (uddrag)",
    author: "Wisława Szymborska",
    year: "1986",
    form: "digt",
    source: "Uddrag af Możliwości fra samlingen Ludzie na moście, 1986",
    text: "Jeg foretrækker biograf.\nJeg foretrækker katte.\nJeg foretrækker Dickens frem for Dostojevskij.\nJeg foretrækker at holde af mennesker\nfrem for at elske menneskeheden.\nJeg foretrækker at have en nål og tråd ved hånden.\nJeg foretrækker det latterlige ved at skrive digte\nfrem for det latterlige ved ikke at gøre det.",
  },
  {
    title: "Karrusellen",
    author: "Rainer Maria Rilke",
    year: "1907",
    form: "digt",
    source: "Digtet Das Karussell fra Neue Gedichte, 1907",
    text: "Med tag og skygge drejer\nen lille stund den flok af brogede heste,\nalle fra det land, der tøver længe,\nfør det går under.\n\nOg af og til en hvid elefant.\n\nOg det går rundt, og det har travlt med at slutte,\nog drejer bare rundt og har intet mål.",
  },
  {
    title: "Fra Gennem byen sidste gang (uddrag)",
    author: "Dan Turèll",
    year: "1975",
    form: "digt",
    source: "Uddrag af Hyldest til hverdagen fra samlingen Gennem byen sidste gang, 1975",
    text: "Jeg holder af hverdagen.\nMest af alt holder jeg af hverdagen.\nDen langsomme opvågnen til den kendte lyd af skraldevognen\nog kaffekopper og fjerne trafik\nog ens elskedes lyse fodtrin i entreen.",
  },
  {
    title: "Til en havn",
    author: "Charles Baudelaire",
    year: "1869",
    form: "uddrag",
    source: "Uddrag af prosadigtet Le Port fra Le Spleen de Paris, udgivet 1869",
    text: "En havn er et yndigt opholdssted for en sjæl træt af livets kampe. Himlens vidde, skyernes bevægelige arkitektur, havets skiftende farver, fyrenes blink – alt sammen et prisme, der er vidunderligt egnet til at underholde øjnene uden nogensinde at trætte dem.",
  },
  {
    title: "Sensommer",
    author: "Henrik Nordbrandt",
    year: "1980",
    form: "digt",
    source: "Efter Henrik Nordbrandts kendte novemberdigt – gengivet efter hukommelsen",
    text: "Året har 16 måneder: november,\ndecember, januar, februar, marts, april,\nmaj, juni, juli, august, september,\noktober, november, november, november, november.",
  },
  {
    title: "Løvfald",
    author: "Yosa Buson",
    year: "1770",
    form: "digt",
    source: "Gendigtet fra japansk efter to haikuer af Buson, 1700-tallet",
    text: "Klokken slår.\nOg tempelklokkens tone\nbliver i blomsten.\n\nEn efterårsaften –\nog jeg tænder lampen\nog sætter mig ned uden mål.",
  },
  {
    title: "Om at gå",
    author: "Simone Weil",
    year: "1947",
    form: "uddrag",
    source: "Uddrag om opmærksomhed fra Tyngden og nåden (La Pesanteur et la grâce), 1947",
    text: "Opmærksomhed er den sjældneste og reneste form for gavmildhed. Den kræver, at man sætter sit eget jeg til side og lader tingene komme, som de er. Kun den, der kan vente uden at gribe, ser noget.",
  },
  {
    title: "Ars poetica (uddrag)",
    author: "Czesław Miłosz",
    year: "1968",
    form: "digt",
    source: "Uddrag af digtet Ars poetica?, 1968",
    text: "Jeg har altid tragtet efter en rummeligere form,\nsom ikke ville være for poesi eller prosa\nog ville tillade os at forstå hinanden uden at udsætte\nnogen, hverken forfatter eller læser, for pinsler af højere orden.",
  },
  {
    title: "Improvisationen",
    author: "efter John Coltrane",
    form: "uddrag",
    source: "Frit gengivet efter John Coltranes egne ord om improvisation – ikke et ordret citat",
    text: "Man begynder midt i noget, man ikke kender. Man spiller, indtil man finder det, og så bliver man ved, til det finder én. Der er ingen fejl – der er kun steder, man endnu ikke har været.",
  },
  {
    title: "Om at slå bolden",
    author: "Torben Ulrich",
    form: "uddrag",
    source: "Frit gengivet efter Torben Ulrich – ikke et ordret citat",
    text: "Det handler ikke om at vinde bolden. Det handler om at være til stede i det øjeblik, hvor bolden rammer strengene. Alt andet er statistik. Ro og frisind, sagde min far, og han mente det som en teknik.",
  },
  {
    title: "Guldalder (uddrag)",
    author: "Michael Strunge",
    year: "1984",
    form: "digt",
    source: "Gengivet efter hukommelsen i Strunges ånd – ikke et ordret citat",
    text: "Vi er de blå børn i den elektriske nat.\nVi går gennem byen med lyset i lommerne\nog venter på at nogen skal spørge\nhvad vi bærer på.",
  },
  {
    title: "Levende og døde",
    author: "Søren Ulrik Thomsen",
    year: "1981",
    form: "digt",
    source: "Gengivet efter hukommelsen i Søren Ulrik Thomsens ånd – ikke et ordret citat",
    text: "Alt hvad jeg husker,\nhusker jeg forkert,\nog dog er det det eneste,\njeg har at gå efter\ni denne by, hvor gaderne\nskifter navn om natten.",
  },
];

export function currentEditorial(d = new Date()): string {
  return EDITORIALS[d.getMonth()];
}

export function currentObservation(d = new Date()) {
  return OBSERVATIONS[weekOfYear(d) % OBSERVATIONS.length];
}

function dayOfYear(d = new Date()): number {
  const start = Date.UTC(d.getFullYear(), 0, 0);
  const now = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
  return Math.floor((now - start) / 86400000);
}

// Dagens digt – skifter hver dag. Skridtlængden er primisk i forhold til
// listens længde, så vi kommer hele vejen rundt uden at gentage en digter
// to dage i træk.
export function currentReading(d = new Date()) {
  const n = READINGS.length;
  const step = 5;
  return READINGS[(dayOfYear(d) * step) % n];
}

// ––– Ugens blik (kurateret rotation af kunstværker, roterer ugentligt) –––
// Redaktørens egne valg. Alle værker er i public domain og hentes via
// Wikimedia Commons' Special:FilePath (stabil redirect til CDN).
// Skift blot rækkefølge, tilføj eller fjern værker efter smag.
const GAZES: {
  title: string;
  artist: string;
  year?: string;
  medium?: string;
  location?: string;
  imageUrl: string;
  wikiUrl: string;
  note: string; // 2–3 sanselige sætninger. Må gerne bruge markdown wiki-links.
}[] = [
  {
    title: "Interior. Strandgade 30",
    artist: "Vilhelm Hammershøi",
    year: "1901",
    medium: "Olie på lærred",
    location: "Statens Museum for Kunst",
    imageUrl:
      "https://commons.wikimedia.org/wiki/Special:FilePath/Stue%20i%20Strandgade%20med%20solskin%20p%C3%A5%20gulvet.jpg?width=1400",
    wikiUrl: "https://da.wikipedia.org/wiki/Vilhelm_Hammershøi",
    note: "Sollyset falder ind på gulvet, som havde det hele eftermiddagen for sig. [Hammershøi](https://da.wikipedia.org/wiki/Vilhelm_Hammershøi) malede den samme lejlighed i tyve år og fandt hver gang noget nyt at være stille over.",
  },
  {
    title: "Brevlæsende kvinde i blåt",
    artist: "Johannes Vermeer",
    year: "ca. 1663",
    medium: "Olie på lærred",
    location: "Rijksmuseum, Amsterdam",
    imageUrl:
      "https://commons.wikimedia.org/wiki/Special:FilePath/Vermeer%2C%20Johannes%20-%20Woman%20reading%20a%20letter%20-%20ca.%201662-1663.jpg?width=1400",
    wikiUrl: "https://da.wikipedia.org/wiki/Johannes_Vermeer",
    note: "Et brev, et vindue, et menneske der glemmer at trække vejret. [Vermeer](https://da.wikipedia.org/wiki/Johannes_Vermeer) stopper tiden med det blå, og lader os stå lige uden for rummet.",
  },
  {
    title: "Den store bølge ud for Kanagawa",
    artist: "Katsushika Hokusai",
    year: "ca. 1831",
    medium: "Træsnit",
    location: "Fra serien 'Toogtredive udsigter til Fuji'",
    imageUrl:
      "https://commons.wikimedia.org/wiki/Special:FilePath/Tsunami_by_hokusai_19th_century.jpg?width=1400",
    wikiUrl: "https://da.wikipedia.org/wiki/Den_store_bølge_ud_for_Kanagawa",
    note: "Bølgen strækker sine fingre mod himlen, men i baggrunden står Fuji ganske roligt. [Hokusai](https://da.wikipedia.org/wiki/Katsushika_Hokusai) minder os om, at det er bjerget der bliver, ikke bølgen.",
  },
  {
    title: "Impression, soleil levant",
    artist: "Claude Monet",
    year: "1872",
    medium: "Olie på lærred",
    location: "Musée Marmottan Monet, Paris",
    imageUrl:
      "https://commons.wikimedia.org/wiki/Special:FilePath/Monet_-_Impression,_Sunrise.jpg?width=1400",
    wikiUrl: "https://da.wikipedia.org/wiki/Impression,_soleil_levant",
    note: "En morgen ved havnen i Le Havre. [Monet](https://da.wikipedia.org/wiki/Claude_Monet) malede lyset før tingene, og gav en hel bevægelse dens navn.",
  },
  {
    title: "Vandreren over tågehavet",
    artist: "Caspar David Friedrich",
    year: "1818",
    medium: "Olie på lærred",
    location: "Hamburger Kunsthalle",
    imageUrl:
      "https://commons.wikimedia.org/wiki/Special:FilePath/Caspar_David_Friedrich_-_Wanderer_above_the_sea_of_fog.jpg?width=1400",
    wikiUrl: "https://da.wikipedia.org/wiki/Vandreren_over_tågehavet",
    note: "En mand står med ryggen til os og ser ud i det uvisse. [Friedrich](https://da.wikipedia.org/wiki/Caspar_David_Friedrich) inviterer læseren ind i sit eget bryst – det er dig, der står deroppe.",
  },
  {
    title: "The Fighting Temeraire",
    artist: "J.M.W. Turner",
    year: "1839",
    medium: "Olie på lærred",
    location: "National Gallery, London",
    imageUrl:
      "https://commons.wikimedia.org/wiki/Special:FilePath/Turner,_J._M._W._-_The_Fighting_T%C3%A9m%C3%A9raire_tugged_to_her_last_Berth_to_be_broken.jpg?width=1400",
    wikiUrl: "https://en.wikipedia.org/wiki/The_Fighting_Temeraire",
    note: "En gammel krigssejler trækkes af en lille dampbåd mod sin sidste havn. [Turner](https://da.wikipedia.org/wiki/J._M._W._Turner) maler afskeden med en verden – og en solnedgang der ved det.",
  },
  {
    title: "Sommeraften ved Skagens strand",
    artist: "P.S. Krøyer",
    year: "1893",
    medium: "Olie på lærred",
    location: "Skagens Museum",
    imageUrl:
      "https://commons.wikimedia.org/wiki/Special:FilePath/Kroyer%20summerevening%20southern%20beach.jpg?width=1400",
    wikiUrl: "https://da.wikipedia.org/wiki/Peder_Severin_Krøyer",
    note: "Den blå time hvor havet og himlen er samme stof. [Krøyer](https://da.wikipedia.org/wiki/Peder_Severin_Krøyer) og Marie går langs vandet, og alt hvad man kan gøre er at gå med.",
  },
  {
    title: "Udsigt fra Dosseringen ved Sortedamssøen",
    artist: "Christen Købke",
    year: "1838",
    medium: "Olie på lærred",
    location: "Statens Museum for Kunst",
    imageUrl:
      "https://commons.wikimedia.org/wiki/Special:FilePath/Christen_K%C3%B8bke_-_A_View_from_Dosseringen_near_the_Sortedam_Lake_Looking_towards_the_N%C3%B8rrebro_District_-_Google_Art_Project.jpg?width=1400",
    wikiUrl: "https://da.wikipedia.org/wiki/Christen_Købke",
    note: "En almindelig eftermiddag ved en sø i en dansk by, malet som var det en åbenbaring. [Købke](https://da.wikipedia.org/wiki/Christen_Købke) elskede det nære så meget, at han fik det til at gløde stille.",
  },
  {
    title: "Jægerne i sneen",
    artist: "Pieter Bruegel den Ældre",
    year: "1565",
    medium: "Olie på træ",
    location: "Kunsthistorisches Museum, Wien",
    imageUrl:
      "https://commons.wikimedia.org/wiki/Special:FilePath/Pieter_Bruegel_the_Elder_-_Hunters_in_the_Snow_(Winter)_-_Google_Art_Project.jpg?width=1400",
    wikiUrl: "https://da.wikipedia.org/wiki/Pieter_Bruegel_den_Ældre",
    note: "Tre jægere trasker hjem i det tunge sneskær, mens landsbyen skøjter under dem. [Bruegel](https://da.wikipedia.org/wiki/Pieter_Bruegel_den_Ældre) rummer en hel vinter i ét billede.",
  },
  {
    title: "Filosoffen i meditation",
    artist: "Rembrandt van Rijn",
    year: "1632",
    medium: "Olie på egetræ",
    location: "Louvre, Paris",
    imageUrl:
      "https://commons.wikimedia.org/wiki/Special:FilePath/Rembrandt%20-%20The%20Philosopher%20in%20Meditation.jpg?width=1400",
    wikiUrl: "https://en.wikipedia.org/wiki/Philosopher_in_Meditation",
    note: "Et vindue, en vindeltrappe, en gammel mand der tænker. [Rembrandt](https://da.wikipedia.org/wiki/Rembrandt) maler det halve i lys og det halve i skygge – det er sådan et sind ser ud.",
  },
];

export function currentGaze(d = new Date()) {
  return GAZES[weekOfYear(d) % GAZES.length];
}


// ––– Kære læser (blød hilsen, roterer dagligt) –––
const GREETINGS: string[] = [
  "Godt du er her. Sæt dig et øjeblik, træk vejret roligt, og lad dagen begynde med noget, der er værd at læse langsomt.",
  "Velkommen tilbage. Vi har samlet et par tekster, der egner sig til en kop kaffe og et vindue med lys i.",
  "Sikke en god idé at komme forbi. Læn dig lidt tilbage – der er ingen, der har travlt her.",
  "Kom indenfor. Dagens strejf er små ting at tage med sig ud i verden, ikke opgaver at klare.",
  "Godmorgen, eller godaften, alt efter hvornår du læser. Vi har lagt noget frem, der gerne må bruge lidt tid.",
  "Rart at se dig. Læs det, der kalder – og lad resten stå. Det står her stadig i morgen.",
  "Her er en lille pause i dagen. Tag den med.",
];

export function currentGreeting(d = new Date()): string {
  const doy = Math.floor(
    (Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()) -
      Date.UTC(d.getUTCFullYear(), 0, 0)) /
      86_400_000,
  );
  return GREETINGS[doy % GREETINGS.length];
}

/**
 * Tidspunkt-baseret tiltale på dansk (Europe/Copenhagen).
 * Bruges som blød åbning foran "Kære læser"-hilsenen.
 */
export function timeOfDaySalutation(d = new Date()): string {
  const hourStr = new Intl.DateTimeFormat("da-DK", {
    hour: "2-digit",
    hour12: false,
    timeZone: "Europe/Copenhagen",
  }).format(d);
  const hour = parseInt(hourStr, 10);
  if (hour >= 5 && hour < 10) return "Godmorgen";
  if (hour >= 10 && hour < 12) return "God formiddag";
  if (hour >= 12 && hour < 17) return "God eftermiddag";
  if (hour >= 17 && hour < 22) return "God aften";
  return "God nat";
}

export type DaypartSlot = "morning" | "afternoon" | "evening" | "night";

export function currentDaypartSlot(d = new Date()): DaypartSlot {
  const hourStr = new Intl.DateTimeFormat("en-GB", {
    hour: "2-digit",
    hour12: false,
    timeZone: "Europe/Copenhagen",
  }).format(d);
  const hour = parseInt(hourStr, 10);
  if (hour >= 5 && hour < 12) return "morning";
  if (hour >= 12 && hour < 17) return "afternoon";
  if (hour >= 17 && hour < 22) return "evening";
  return "night";
}


// ––– PS (redaktionens bemærkning, roterer dagligt) –––
// En kort, personlig note fra kuratoren. Ikke en opgave, ikke en life-hack,
// ikke en gajol-æske. Bare noget at tage med sig – om kuren, om smagen,
// om at læse langsomt.
const POSTSCRIPTS: string[] = [
  "Jeg læser hvert eneste svar. Skriv, hvis noget her rammer dig.",
  "Kuren er ikke en dagsorden. Den er en måde at blive ved på, også når man ikke helt ved hvorfor.",
  "Læs det, der kalder på dig. Lad resten stå. Det står her stadig i morgen.",
  "Jeg samler ikke svar. Jeg samler spørgsmål, der fortjener at blive stillet langsomt.",
  "Nogle tekster skal man snige sig ind på. Giv dem tiden.",
  "Det meste, der er værd at læse, kræver at man lægger telefonen fra sig. Det ved du godt. Det ved jeg også.",
  "En god iagttagelse er som et glas vin: den åbner sig, hvis man venter lidt.",
  "Jeg har ingen opskrift på, hvad der gør en dag bedre. Men jeg ved, at langsomhed hjælper.",
  "Der er en særlig kvalitet ved det uafsluttede. En sætning, man vender tilbage til. Et billede, man ikke kan slippe.",
  "Tak fordi du læser med. Det betyder mere, end man skulle tro.",
  "Nogle artikler kommer med det samme. Andre må jeg finde frem til igen og igen. Det gode gemmer sig ikke altid øverst i bunken.",
  "Jeg tror på, at langsomhed er en handling. At læse én ting ordentligt er en handling. At dele den videre er en handling.",
  "Der er dage, hvor jeg finder noget, jeg ikke vidste, jeg ledte efter. Dem holder jeg særligt meget af.",
  "Hvis du ser noget her, der får dig til at stoppe op, så send det videre. Det er sådan, det stille fællesskab vokser.",
  "Jeg prøver at holde kuren fri for larm. Når det lykkes, er det fordi du læser med.",
  "En god tekst gør ikke alting klart. Den gør noget uklart, man kan gå rundt med.",
];

export function currentPostscript(d = new Date()): string {
  // Roterer dagligt, så nyhedsbrevet får et nyt PS hver dag i stedet for
  // at hænge fast på samme anbefaling en hel uge.
  const doy = Math.floor(
    (Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()) -
      Date.UTC(d.getUTCFullYear(), 0, 0)) /
      86_400_000,
  );
  return POSTSCRIPTS[doy % POSTSCRIPTS.length];
}

const TOPIC_LABELS_LOWER: Record<string, string> = {
  vin: "vin", kunst: "kunst", musik: "musik", poesi: "poesi",
  kultur: "kultur", mad: "mad", cykling: "cykling",
  levekunst: "levekunst", have: "have",
};

/**
 * Kort, naturlig linje om hvad der venter i dagens strejf, fx
 * "I dag venter små strejf om vin, jazz og en havedag."
 */
export function todaysInvitation(topics: string[]): string {
  const unique = Array.from(new Set(topics.filter(Boolean)));
  if (unique.length === 0) return "";
  const labels = unique.map((t) => TOPIC_LABELS_LOWER[t] ?? t);
  const list =
    labels.length === 1
      ? labels[0]
      : labels.length === 2
        ? `${labels[0]} og ${labels[1]}`
        : `${labels.slice(0, -1).join(", ")} og ${labels[labels.length - 1]}`;
  return `I dag venter små strejf om ${list} – læs dem langsomt.`;
}
